import AnchorCard from '../../common/component/AnchorCard';
import {Page} from '../../common/constant/page';
import useScreenType from '../../common/hook/useScreenType';
import ContentLikeV4 from '../../commonSub/component/ContentLikeV4';
import {EVENT_MAX_WIDTH_272_CN} from '../common';
import {IEventAnchorCardV4} from '../type';

interface Props {
  contentAnchor: IEventAnchorCardV4;
  showContentLike?: boolean;
  onClickLike?: (contentAnchor: IEventAnchorCardV4, isLike: boolean) => void;
  onClickKeyword?: (contentAnchor: IEventAnchorCardV4, keyword: string) => void;
  onClickAnchor?: (contentAnchor: IEventAnchorCardV4) => void;
}

export default function EventAnchorCardV4({
  contentAnchor,
  showContentLike = true,
  onClickLike,
  onClickKeyword,
  onClickAnchor,
}: Props) {
  const {id, sid, seoKeywords, descLine2, isLike} = contentAnchor;
  const {isSmall, isMedium} = useScreenType();

  const handleClickLike = async (isLike: boolean) => {
    await onClickLike?.(contentAnchor, isLike);
  };

  const handleClickKeyword = (keyword: string) => {
    onClickKeyword?.(contentAnchor, keyword);
  };

  return (
    <div className="flex flex-col gap-y-12">
      <AnchorCard
        pageInfo={{page: Page.Content, id, sid}}
        blackMaskOpacity="50%"
        desc={contentAnchor.authors}
        content={contentAnchor}
        mainImgClassName="md:right-18"
        customAspectRatio={
          isSmall ? 230 / 353 : isMedium ? 228 / 454 : 298 / 594
        }
        onClick={onClickAnchor ? () => onClickAnchor(contentAnchor) : undefined}
      />
      {showContentLike && (
        <ContentLikeV4
          isLike={!!isLike}
          isOnlyDarkMode={true}
          description={descLine2}
          keywords={seoKeywords}
          descClassName={EVENT_MAX_WIDTH_272_CN}
          onClickLike={handleClickLike}
          onClickKeyword={handleClickKeyword}
        />
      )}
    </div>
  );
}
